import { z } from "zod";
const attributesIconSchema = z.object({
  src: z.string(),
  title: z.string().optional(),
  class: z.string().optional(),
  size: z.string().optional()
});
export {
  attributesIconSchema
};
//# sourceMappingURL=attributes.js.map
